module.exports = __webpack_public_path__ + "static/gcmobile-ad0b2cb798feff73ffe0464d51bae5e7.png";